import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { getAgeingTreeAction } from "../../actions/issueDetail.action";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { get } from "lodash";
import { isValidArray } from "../../helper";
import { STATUS } from "../../constant";
import { ComponentLoader } from "../../component/ComponentLoader";

class AgeingTree extends Component {
  state = {
    treeData: {},
    treeDto: [],
    isTreeLoading: STATUS.LOADING
  };

  async componentDidMount() {
    const { issueData, getAgeingTreeDispatch } = this.props;
    const response =
      get(issueData, "data.id") &&
      (await getAgeingTreeDispatch(undefined, {
        issueId: get(issueData, "data.id")
      }));
    if (response) {
      const { data, status } = response;
      this.setState({
        treeData: data,
        treeDto: data,
        isTreeLoading: (status && STATUS.SUCCESS) || STATUS.ERROR
      });
    }
  }

  recursive = data => {
    return this.outerTemplate(data);
  };

  outerTemplate = data => {
    const childs = get(data, "childs");
    return (
      <td colspan={childs.length}>
        {(!isValidArray(childs) && this.template(data)) || null}
        {(isValidArray(childs) && (
          <table>
            <tr>
              <td colspan={childs.length}>{this.template(data) || null}</td>
            </tr>
            <tr>
              {(childs || []).map(tree => {
                return (
                  <td
                    colspan={
                      isValidArray(get(tree, "childs")) &&
                      get(tree, "childs").length
                    }
                  >
                    {this.recursive(tree, 0) || null}
                  </td>
                );
              }) || null}
            </tr>
          </table>
        )) ||
          null}
      </td>
    );
  };

  template = data => {
    const treeDto = data;
    const groupDto = get(treeDto, "groupAgeingDTOS");
    const keyName = groupDto && Object.keys(groupDto)[0];
    const status = groupDto && groupDto[keyName][0]["status"];
    const resolvedClass =
      ((status && status.toLowerCase()) === "resolved" && "state-resolved") ||
      "";
    const workingClass = "state-working";
    const rejectedClass =
      (status && status.toLowerCase() === "reject" && "state-rejected") || "";
    const childs = treeDto.childs;

    return (
      <div
        className={`ageing-block has-parent ${rejectedClass ||
          resolvedClass ||
          workingClass} ${isValidArray(childs) && "has-child"}`}
      >
        <div className="ageing-top-wrapper">
          <div className="ageing-top">
            <div className="ageing-time">
              From <b> {keyName && groupDto[keyName][0]["totalDays"]} </b> Days
            </div>
            <div className="avatar-image-wrapper">
              <div className="avatar-image" />
            </div>
          </div>
        </div>
        <div className="ageing-bottom-wrapper">
          <div className="ageing-bottom">
            <div className="ageing-assignee">
              Assigned To
              <b>{(keyName && groupDto[keyName][0]["groupName"]) || "NA"}</b>
              <div className="issue-number">
                Issue <b># {get(treeDto, "issueId") || "NA"}</b>
              </div>
            </div>
          </div>
          {(resolvedClass && <div className="ageing-state">Resolved</div>) ||
            null}
          {(rejectedClass && <div className="ageing-state">Rejected</div>) ||
            null}
        </div>
      </div>
    );
  };

  render() {
    const { treeData, treeDto, isTreeLoading } = this.state;
    const {
      issueData,
      show,
      toogleTreeChart,
      issueId,
      treeParent
    } = this.props;
    const groupDto = treeDto[0] && treeDto[0].groupAgeingDTOS;
    const keyName = groupDto && Object.keys(groupDto)[0];
    const template =
      isValidArray(treeData) &&
      treeData.map(tree => {
        return this.recursive(tree, 0);
      });

    return (
      <React.Fragment>
        <Modal show={show} dialogClassName="modal-ageing-tree">
          <ComponentLoader isLoading={isTreeLoading === STATUS.LOADING} />
          <Modal.Header
            closeButton
            onClick={() => {
              toogleTreeChart && toogleTreeChart();
            }}
          />
          <Modal.Body>
            <div className="modal-body-inner">
              <div className="ageing-tree-header-wrapper">
                <div className="ageing-tree-header">
                  <div className="issue-number">
                    Issue <b># {get(issueData, "data.id")} </b>
                  </div>
                  <h2 className="issue-category">
                    {get(issueData, "data.issueCategory")}
                  </h2>
                  <div className="issue-recipient">
                    Recipient State -{" "}
                    <b>{get(issueData, "data.recipientGroup")}</b>
                  </div>
                  <div className="issue-title">
                    {get(issueData, "data.title", "NA")}
                  </div>
                  <div className="issue-list-desc">
                    {get(issueData, "data.description", "NA")}
                  </div>
                </div>
              </div>
              <div className="ageing-tree-wrapper">
                <table className="ageing-tree">
                  <tr>
                    <td colspan={isValidArray(treeDto) && treeDto.length}>
                      <div
                        className={`ageing-block ${isValidArray(treeDto) &&
                          "has-child"}`}
                      >
                        <div className="ageing-top-wrapper">
                          <div className="ageing-top">
                            <div className="avatar-image-wrapper">
                              <div className="avatar-image" />
                            </div>
                          </div>
                        </div>
                        <div className="ageing-bottom-wrapper">
                          <div className="ageing-bottom">
                            <div className="ageing-time">
                              From
                              <b>
                                {keyName && get(treeParent, "totalDays", "NA")}
                              </b>
                              Days
                            </div>
                            <div className="ageing-assignee">
                              Assigned To
                              <b>{get(treeParent, "groupName", "NA")}</b>
                              <div className="issue-number">
                                Issue <b># {issueId || "NA"}</b>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>{template || null}</tr>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    issueData: state.issueDetailsReducer.issueData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAgeingTreeDispatch: getAgeingTreeAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgeingTree);
